/* Global imports. */
import React from "react";
import KontentRichText from "@components/KontentRichText"

interface Props {
  recipe: any;
}

const Recipe = ({ recipe }: Props) => {
  const ingredientsArray = recipe.ingredients.value.split(',')
  return (
    <div>
      <div className="flex justify-start w-full">
        <a href="#ingredients" data-smoothscroll="" className="relative pl-4 pr-8 m-0 mr-4 button">
          Ingredients
          <span className="absolute block w-4 h-4 right-2 top-1/2 -translate-y-2/4">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
              <path style={{fill:"#E82200"}} d="M35 2v36H4.3V2H35m2-2H2.3v40H37V0z"></path>
              <path style={{fill:"#E82200"}} d="M30 30.3H18.7v-2H30v2zm-16 0H9.3v-2H14v2zm-2.3-7.6L8.9 20l1.4-1.4 1.3 1.3 4-4 1.4 1.4-5.3 5.4zM30 21H18.7v-2H30v2zm-18.3-7.6l-2.8-2.7 1.4-1.4 1.3 1.3 4-4L17.1 8l-5.4 5.4zM30 11.7H18.7v-2H30v2z"></path>
            </svg>
          </span>
        </a>
        <a href="#method" data-smoothscroll="" className="relative pl-4 pr-8 m-0 mr-4 button">
          Method
          <span className="absolute block w-4 h-4 right-2 top-1/2 -translate-y-2/4">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
              <path style={{fill:"#E82200"}} d="M30.4 7c-.4 0-.7 0-1.1.1A9.66 9.66 0 0 0 20 0c-2.6 0-5 1-6.8 2.8A8.9 8.9 0 0 0 10.8 7c-.4-.1-.8-.1-1.2-.2C4.3 7 0 11.2 0 16.6c.1 5 4 9 8.9 9.4v14h22.3V26a9.9 9.9 0 0 0 8.9-9.5c-.2-5.2-4.4-9.4-9.7-9.5zm-1.3 31H10.9v-3.1h18.3V38zm1.2-13.9h-1.1V33H21v-6.3h-2V33h-8.1v-8.9h-1c-4.2 0-7.7-3.3-7.8-7.5 0-4.2 3.4-7.6 7.6-7.7.3 0 .6 0 .8.1v.7c0 1.3.3 2.7.9 3.9l.4.9 1.8-.9-.6-1c-.4-.9-.7-1.9-.7-3 0-2 .8-3.9 2.2-5.4C16.1 2.8 18 2 20 2c4.2 0 7.6 3.4 7.6 7.6 0 1-.2 2-.7 3l-.4.9 1.8.9.4-.9c.6-1.2.9-2.5.9-3.9v-.5c.3-.1.5-.1.8-.1 4.2 0 7.6 3.4 7.6 7.6a7.8 7.8 0 0 1-7.7 7.5z"></path>
            </svg>
          </span>
        </a>
      </div>
      <ul className="grid gap-4 p-6 pl-10 mt-10 mb-8 border rounded-md !list-none">
        <li className="relative col-span-4 pl-14">
          <span className="absolute top-0 left-0 block w-6 h-6">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
              <path d="M20 2c9.9 0 18 8.1 18 18s-8.1 18-18 18S2 29.9 2 20 10.1 2 20 2m0-2C9 0 0 9 0 20s9 20 20 20 20-9 20-20S31 0 20 0z"></path>
              <path d="M31.4 21H20c-.6 0-1-.4-1-1V8.6c0-.6.4-1 1-1s1 .4 1 1V19h10.4c.6 0 1 .4 1 1s-.4 1-1 1z"></path>
            </svg>
          </span>
          <h5 className="mb-0 font-sans text-sm text-gray-400">Total time</h5>
          <p className="mb-0 font-sans">{recipe.cook_time && recipe.cook_time.value}</p>
        </li>
        <li className="relative col-span-3">
          <h5 className="mb-0 font-sans text-sm text-gray-400">Prep time</h5>
          <p className="mb-0 font-sans">{recipe.prep_time && recipe.prep_time.value}</p>
        </li>
        <li className="relative col-span-12 pl-14">
          <span className="absolute top-0 left-0 block w-6 h-6">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
              <path d="M.58 11.87L1.32 10l9.1 3.64-.74 1.86zM2.1 2.53L3.5 1.1 13.7 11.3l-1.41 1.42zM2 23.5h36v2H2zM36.8 20.5l-1.7-1a9.99 9.99 0 0 0-8.6-14.9c-4.2 0-8 2.7-9.3 6.7l-1.9-.6c1.6-4.8 6.1-8 11.2-8C33 2.7 38.3 8 38.4 14.5c0 2.1-.6 4.2-1.6 6z"></path>
              <path d="M37.9 21A18 18 0 0 1 18 36.9C9.6 36 3 29.4 2.1 21h35.8zm2.1-2H0c0 11 9 20 20 20s20-9 20-20z"></path>
              <path d="M25.5 21v-1c0-4.5-3.6-8.1-8.1-8.1-2.2 0-4.2.8-5.7 2.4A8.2 8.2 0 0 0 9.3 20v1h-2v-1a10 10 0 0 1 3-7.1 10 10 0 0 1 7.1-3c5.6 0 10.1 4.5 10.1 10.1v1h-2z"></path>
            </svg>
          </span>
          <h5 className="mb-0 font-sans text-sm text-gray-400">Amount</h5>
          <p className="mb-0 font-sans">{recipe.serves && recipe.serves.value}</p>
        </li>
        <li id="ingredients" className="relative col-span-12 pl-14">
          <span className="absolute top-0 left-0 block w-6 h-6">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
              <path d="M35 2v36H4.3V2H35m2-2H2.3v40H37V0z"></path>
              <path d="M30 30.3H18.7v-2H30v2zm-16 0H9.3v-2H14v2zm-2.3-7.6L8.9 20l1.4-1.4 1.3 1.3 4-4 1.4 1.4-5.3 5.4zM30 21H18.7v-2H30v2zm-18.3-7.6l-2.8-2.7 1.4-1.4 1.3 1.3 4-4L17.1 8l-5.4 5.4zM30 11.7H18.7v-2H30v2z"></path>
            </svg>
          </span>
          <h5 className="font-sans text-sm text-gray-400">Ingredients</h5>
          <ul className="text-base">
              {ingredientsArray.map((item) => {
                  return <li className="font-sans"> {item}</li>
              })}
          </ul>
        </li>
      </ul>
  <div id="method" className="main-content--richtext richtext--generic">
  {recipe.method &&  
   <KontentRichText value={recipe.method} />
    }
  </div>
  </div>
  )
};

export default Recipe;
